module.exports = __webpack_public_path__ + "static/img/help_01intro_02.5949629.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stufdback/help_01intro_02.png
// module id = 717
// module chunks = 140